export const BusTransferType = {
	
	/// <summary>
	/// 少换乘
	/// </summary>
	LessTransfer: "2",
	/// <summary>
	/// 少步行
	/// </summary>
	LessWalk: "4",
	/// <summary>
	/// 更快捷
	/// </summary>
	MoreQuick: "1",
	/// <summary>
	/// 不坐地铁
	/// </summary>
	NotSubway: "8"


}//end BusTransferType

